import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    collectionList: [],
    keyValueHeader: [],
    keyValueData: {},
  },
  getters: {
    collectionList: (state) => state.collectionList,
    keyValueHeader: (state) => state.keyValueHeader,
    keyValueData: (state) => state.keyValueData,
  },
  actions: {
    loadCollectionList(context) {
      return new Promise((resolve, reject) => {
        alice
          .getCollection()
          .then((response) => {
            context.commit('setCollectionListData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createCollection(context, { collectionName, keyName, sourceType }) {
      return new Promise((resolve, reject) => {
        alice
          .createCollection(collectionName, keyName, sourceType)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteCollection(context, { collectionId }) {
      return new Promise((resolve, reject) => {
        alice
          .deleteCollection(collectionId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCollectionHeaderById(context, { collectionId }) {
      return new Promise((resolve, reject) => {
        alice
          .getCollectionHeaderById(collectionId)
          .then((response) => {
            context.commit('setKeyValueHeaderData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getKeyValuePage(context, {
      collectionId, size, page, searchPhrase,
    }) {
      return new Promise((resolve, reject) => {
        let realPageNo = page - 1;
        if (realPageNo < 0) {
          realPageNo = 0;
        }
        alice
          .getKeyValuePage(collectionId, size, realPageNo, searchPhrase)
          .then((response) => {
            context.commit('setKeyValueData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    addKeyValue(context, { collectionId, key, value }) {
      return new Promise((resolve, reject) => {
        alice
          .addKeyValue(collectionId, key, value)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateKeyValue(context, { collectionId, id, data }) {
      return new Promise((resolve, reject) => {
        alice
          .updateKeyValue(collectionId, id, data)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteKeyValue(context, { collectionId, id }) {
      return new Promise((resolve, reject) => {
        alice
          .deleteKeyValue(collectionId, id)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateLocalRowData(context, data) {
      context.commit('updateLocalRowData', data);
    },
  },
  mutations: {
    setCollectionListData(state, data) {
      Vue.set(state, 'collectionList', data);
    },
    setKeyValueHeaderData(state, data) {
      Vue.set(state, 'keyValueHeader', data);
    },
    setKeyValueData(state, data) {
      Vue.set(state, 'keyValueData', data);
    },
    updateLocalRowData(state, data) {
      const { keyValueData } = state;
      const { rowId, rowData } = data;
      for (let i = 0; i < keyValueData.content.length; i += 1) {
        if (keyValueData.content[i].id === rowId) {
          // Set key value
          Vue.set(keyValueData.content, i, rowData);
          break;
        }
      }
    },
  },
};
